<template>
  <div>
    <div style="margin-bottom: 15px">
      <span>选择学校：</span>
      <a-select v-model="bizOrgId" :allowClear="true" style="width: 15%">
        <a-select-option v-for="bizOrg in bizOrgList" :value="bizOrg.id" :key="bizOrg.id">
          {{ bizOrg.name }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">姓名或手机号：</span>
      <a-input allow-clear v-model="keyword" style="width: 10%"/>
      <span style="margin-left: 12px">状态：</span>
      <a-select v-model="status" :allowClear="true" style="width: 10%">
        <a-select-option value="workerTake" key="workerTake">
          清洗中
        </a-select-option>
        <a-select-option value="workerPut" key="workerPut">
          用户待取件
        </a-select-option>
        <a-select-option value="userTake" key="userTake">
          已完成
        </a-select-option>
        <a-select-option value="close" key="close">
          异常关闭
        </a-select-option>
      </a-select>
      <a-button type="primary" icon="search" style="margin-left: 15px" @click="handleSearch">查询</a-button>
    </div>
    <a-divider/>

    <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="pagination"
        @change="handleTableChange"
        size="middle"
        rowKey="id"
        :loading="loading"
        bordered>
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="status" slot-scope="text, record">
        <span v-if="text === 'workerTake'">
          <a-tag color="orange">清洗中</a-tag>
        </span>
        <span v-if="text === 'workerPut'">
          <a-badge v-if="record.userTakeExpired" count="超时未取">
            <a-tag color="blue">用户待取件</a-tag>
          </a-badge>
          <a-tag v-else color="blue">用户待取件</a-tag>
        </span>
        <span v-if="text === 'userTake'">
          <a-tag color="green">已完成</a-tag>
        </span>
        <span v-if="text === 'close'">
          <a-tag color="red">异常关闭</a-tag>
        </span>
      </span>
      <!--      <template slot="action" slot-scope="text, record">
              <a-button :disabled="true" style="padding: 0 3px;" type="link">
                <a-icon type="edit"/>
                <span style="margin-left: 2px">详情</span>
              </a-button>
            </template>-->
    </a-table>
  </div>
</template>

<script>
import orderService from '@/service/order'
import bizOrgService from '@/service/bizOrg'
import {trim} from "core-js/internals/string-trim";

export default {
  name: "OrderList",
  data() {
    return {
      columns: [
        {title: '#', scopedSlots: {customRender: 'serial'}, align: 'center'},
        {title: '学校', dataIndex: 'bizOrgName', align: 'center'},
        {title: '用户姓名', dataIndex: 'realName', align: 'center'},
        {title: '手机号', dataIndex: 'mobile', align: 'center'},
        {title: '状态', dataIndex: 'status', scopedSlots: {customRender: 'status'}, align: 'center'},
        {title: '取件智能柜', dataIndex: 'cabinetLocation', align: 'center', customRender: (text,record) => text?text + record.cabinetCellCode + '柜门': '-'},
        {title: '盘点上报时间', dataIndex: 'workerTakeTime', align: 'center', customRender: (text) => text?text: '-'},
        {title: '配送入柜时间', dataIndex: 'workerPutTime', align: 'center', customRender: (text) => text?text: '-'},
        {title: '用户取件时间', dataIndex: 'userTakeTime', align: 'center', customRender: (text) => text?text: '-'},
        {title: '配送员', dataIndex: 'workerName', align: 'center', customRender: (text) => text?text: '-'},
        // {title: '操作', width: "10%", dataIndex: 'action', scopedSlots: {customRender: 'action'}, align: 'center'}
      ],
      rows: [],
      pagination: {},

      keyword: '',
      bizOrgId: null,
      bizOrgList: [],
      status: null,
      loading: false,
    };
  },
  mounted() {
    let params = {
      current: 1,
      size: 10,
    }
    this.fetch(params)

    bizOrgService.queryBriefList().then((res) => {
      this.bizOrgList = res.data
    })
  },
  methods: {
    handleTableChange(pagination) {
      this.fetch(pagination)
    },
    handleSearch() {
      this.fetch()
    },
    fetch(page) {
      this.keyword = trim(this.keyword)
      let params = {
        current: page ? page.current : 1,
        size: page ? page.size : 10,
        keyword: this.keyword,
        bizOrgId: this.bizOrgId,
        status: this.status,
      }
      this.loading = true
      orderService.queryPage(params).then((res) => {
        const pagination = {...this.pagination};
        this.rows = res.data.records
        pagination.current = res.data.current
        pagination.total = res.data.total
        pagination.size = res.data.size + ''
        pagination.showTotal = (total, range) => {
          return `${range[0]}-${range[1]} 总计 ${total} 条`
        }
        this.pagination = pagination
        this.loading = false

        this.$emit('refreshNotification')
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
